import { LIST_WIDTH, ARCHIVED_COLUMN } from 'utils/constants/listview';
export const ruleColumns = [
  { headerName: 'Name', field: 'name', width: 100 },
  { headerName: 'Key', field: 'key', width: 100 },
  { headerName: 'Operator', field: 'operator', width: 100 },
  { headerName: 'Value', field: 'value', width: 100 },
  { headerName: 'Duration', field: 'duration', width: 100 },
  { headerName: 'Category', field: 'eventCategory', width: 100 },
  { headerName: 'Type', field: 'eventType', width: 100 },
];
export const columns = [
  ARCHIVED_COLUMN,
  {
    headerName: 'Asset ID',
    field: 'assetId',
    width: LIST_WIDTH.HUMAN_READABLE_ID,
  },
  { headerName: 'Name', field: 'assetName', width: LIST_WIDTH.xl },
  {
    headerName: 'Category',
    field: 'category',
    cellRenderer: 'activityComponent',
    cellRendererParams: {
      displayType: 'icon',
    },
    width: LIST_WIDTH.default,
  },
  { headerName: 'Type', field: 'typeName', width: LIST_WIDTH.default },
  {
    headerName: 'Assigned To',
    field: 'assignedTo',
    width: LIST_WIDTH.HUMAN_NAME,
  },
  {
    headerName: 'Handover Required',
    field: 'handoverRequired',
    cellRenderer: 'statusComponent',
    width: LIST_WIDTH.default,
  },
  {
    headerName: 'Qualification Required',
    field: 'qualificationRequired',
    cellRenderer: 'statusComponent',
    width: LIST_WIDTH.default,
  },
  {
    headerName: 'Status',
    field: 'status',
    cellRenderer: 'activityComponent',
    width: LIST_WIDTH.STATUS,
  },
  {
    headerName: 'Departments',
    field: 'departments',
    width: LIST_WIDTH.xl,
  },
];
